import React, { useContext, useEffect } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { ThemeProvider } from '@material-ui/core';
import { B2C_REDIRECT } from './constants/links';
import { windowExists, THD_CUSTOMER } from './components/Utils';
import { Error } from './pages';
import { getRoutes } from './routes.js';
import { THDTheme } from './theme';
import './styles/app.scss';
export var App = function (_a) {
    var _b;
    var customerType = _a.customerType, customerRole = _a.customerRole;
    var instance = useContext(AppContext).instance;
    var _c = instance.router, currentRouteName = _c.currentRouteName, currentRouteComponent = _c.currentRouteComponent;
    var routes = getRoutes(currentRouteName, currentRouteComponent);
    var isB2B = customerType.toUpperCase() === 'B2B';
    var isAuthenticated = !!((_b = THD_CUSTOMER()) === null || _b === void 0 ? void 0 : _b.jwt);
    useEffect(function () {
        document.title = 'The Home Depot';
    }, []);
    // if B2C, redirect to a different page (custom link)
    if (isAuthenticated && !isB2B && windowExists()) {
        window.location.href = B2C_REDIRECT;
        return React.createElement(React.Fragment, null); // block api calls and rendering
    }
    return (React.createElement(ThemeProvider, { theme: THDTheme },
        React.createElement(ScrollToTop, null),
        React.createElement(Routes, null,
            React.createElement(Route, { path: routes.perks.path, element: React.createElement(routes.perks.component, { customerType: customerType, customerRole: customerRole }) }),
            React.createElement(Route, { path: routes.rewardsHub.path, element: React.createElement(routes.rewardsHub.component, { customerType: customerType, customerRole: customerRole }) }),
            React.createElement(Route, { path: routes.pricingBenefits.path, element: React.createElement(routes.pricingBenefits.component, { customerType: customerType, customerRole: customerRole }) }),
            React.createElement(Route, { path: "/error", element: React.createElement(Error, null) }),
            React.createElement(Route, { element: React.createElement(Error, null) }))));
};
